// extracted by mini-css-extract-plugin
export default {"font-renta":"MyWorkHours_font-renta__vmquI","myWorkHours":"MyWorkHours_myWorkHours__9XOZG","approved":"MyWorkHours_approved__gB7m1"};